// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2i9PE","left":"InfoRow_left__FMtVg"};